// extracted by mini-css-extract-plugin
export default {"root":"K6bQ4KJJm2IKiwpsaEbs"};